import { trackUserEvent } from '@vend/utilities'
import {
  FulfilmentDetail,
  isDefinedFulfilmentType,
} from '../../models/fulfilment'
import { FulfilmentNoteEntryLocation } from '../../state/slices/uiStateSlice'
import { WEB_REGISTER } from '../../components/web-register.constant'

export interface TrackFulfilmentNoteUsageParams {
  saleId: string
  fulfilmentDetail?: FulfilmentDetail
  location?: FulfilmentNoteEntryLocation
  /** Count of line items requiring fulfilment (delivery/pickup) — excludes
   * take-now items and gift cards. See selectFulfilmentLineItemsProductCount. */
  productCount: number
  /** Sum of quantities for those same fulfilment-only line items. See
   * selectFulfilmentLineItemsTotalQuantity. */
  totalQuantity: number
  saleTotal: number | string
}

/**
 * Fires the "Fulfillment Note" UBE once a sale with a fulfilment note has
 * been paid/finalised — i.e. the sale is locked in. Only fires when a note
 * is actually present; no raw note text is sent (see
 * `fulfilments.note`/`pick_lists.note` in BigQuery for that, joined on
 * `saleId`).
 */
export const trackFulfilmentNoteUsage = ({
  saleId,
  fulfilmentDetail,
  location,
  productCount,
  totalQuantity,
  saleTotal,
}: TrackFulfilmentNoteUsageParams): void => {
  if (!fulfilmentDetail || !isDefinedFulfilmentType(fulfilmentDetail.type)) {
    return
  }

  const note = fulfilmentDetail.note || ''
  if (!note) {
    return
  }

  trackUserEvent(WEB_REGISTER.DISPLAY_NAME, 'Fulfillment Note Added', {
    saleId,
    hasNote: true,
    noteLength: note.length,
    fulfillmentMethod: fulfilmentDetail.type,
    location: location || 'unknown',
    productCount,
    totalQuantity,
    saleTotal,
  })
}
